/* ═══════════════════════════════════════════════════════════════════════
   CRÉAPANEL — assets/cp-lien.js (chargé par snippets/cfg-coeur.liquid, sur les fiches à configurateur)
   R192 « ENREGISTRER MA CONFIGURATION » (Romain ; AUDIT, registre R192 et 15:59 ; plan docs\r192-enregistrer-configuration-plan.md ;
   textes de COMMERCIAL, docs\commercial-r192-textes.md)
   - Un bouton sous « Ajouter au panier » ouvre une fenêtre : le lien personnel, « Copier le lien », « Envoyer par e-mail » (R214)
     (un lien mailto : c'est le client qui l'envoie ; au-delà de 1 800 caractères, le lien est copié à la place).
   - Le lien : l'adresse de la fiche, puis « #cfg=1. » et l'état du configurateur (App.S, sans les montants calculés ni l'état
     passager de l'écran), en JSON compressé (deflate) et écrit en base64 pour adresse ; « 1n. » : sans compression (vieux
     navigateur). La partie « # » ne quitte jamais le navigateur : rien n'est envoyé ni gardé sur le site.
   - Au retour par le lien : la fiche vérifiée, le décor choisi comme par un clic, puis chaque clé remise si elle existe dans
     App.S avec le même type ; le moteur refait tout, au prix du jour. Ce qui n'est plus vendu (décor, épaisseur) reste au
     réglage par défaut, avec un message. Le « #cfg=… » est ensuite retiré de l'adresse.
   ═══════════════════════════════════════════════════════════════════════*/
(function () {
  'use strict';

  var VERSION = '1', MAX_MAIL = 1800;
  var PASSAGERES = ['optionsTotalCents', 'qtyCm', 'unitTotalCents', 'cpBoutClic'];   /* montants recalculés, dernier clic */
  var ETAG_PASSAGERES = ['sel', 'selB', 'view'];                                        /* pièce choisie, vue (cp-etagere) */
  function getApp() { try { return (typeof App !== 'undefined') ? App : window.App; } catch (e) { return window.App; } }
  function num(v) { var n = Number(v); return isFinite(n) ? n : 0; }
  function sorte(v) { return Array.isArray(v) ? 'tableau' : v === null ? 'null' : typeof v; }
  function handle() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function toast(t) { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(t, 'info', 9000); }
  function nomProduit() { var m = document.querySelector('meta[property="og:title"]'); return (m && m.content) || (document.querySelector('h1') || {}).textContent || document.title; }
  function nomDecor(cle) { var o = document.querySelector('#variants-container .variant-opt[data-variant="' + String(cle).replace(/"/g, '') + '"] .variant-name'); return o ? o.textContent.trim() : ''; }

  /* ── 1. L'état et le lien ── */
  function etat(A) {
    var s = {};
    Object.keys(A.S).forEach(function (k) {
      var v = A.S[k]; if (PASSAGERES.indexOf(k) >= 0 || typeof v === 'function' || v === undefined) return;
      try { s[k] = JSON.parse(JSON.stringify(v)); } catch (e) {}
    });
    if (s.cpEtag && typeof s.cpEtag === 'object') ETAG_PASSAGERES.forEach(function (k) { delete s.cpEtag[k]; });
    return { p: handle(), n: nomDecor(A.S.variant), s: s };
  }
  function b64(octets) { var t = ''; for (var i = 0; i < octets.length; i += 0x8000) t += String.fromCharCode.apply(null, octets.subarray(i, i + 0x8000)); return btoa(t).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function deb64(t) { t = t.replace(/-/g, '+').replace(/_/g, '/'); while (t.length % 4) t += '='; var b = atob(t), o = new Uint8Array(b.length); for (var i = 0; i < b.length; i++) o[i] = b.charCodeAt(i); return o; }
  function flux(octets, Flux) { return new Response(new Blob([octets]).stream().pipeThrough(new Flux('deflate-raw'))).arrayBuffer().then(function (b) { return new Uint8Array(b); }); }
  function encoder(obj) {
    var oct = new TextEncoder().encode(JSON.stringify(obj));
    if (typeof CompressionStream !== 'function') return Promise.resolve(VERSION + 'n.' + b64(oct));
    return flux(oct, CompressionStream).then(function (c) { return VERSION + '.' + b64(c); }, function () { return VERSION + 'n.' + b64(oct); });
  }
  function decoder(code) {
    var m = /^(\d+)(n?)\.([A-Za-z0-9_-]+)$/.exec(code || ''); if (!m || m[1] !== VERSION) return Promise.reject(new Error('version'));
    var oct = deb64(m[3]);
    var lire = function (o) { return JSON.parse(new TextDecoder().decode(o)); };
    if (m[2] === 'n') return Promise.resolve(lire(oct));
    if (typeof DecompressionStream !== 'function') return Promise.reject(new Error('décompression'));
    return flux(oct, DecompressionStream).then(lire);
  }
  function adresse(code) {
    var t = /[?&]preview_theme_id=(\d+)/.exec(location.search);       /* aperçu d'un thème : gardé, pour rouvrir la même copie */
    return location.origin + location.pathname + (t ? '?preview_theme_id=' + t[1] : '') + '#cfg=' + code;
  }

  /* ── 2. Le bouton et la fenêtre ── */
  function bouton() {
    var add = document.getElementById('btn-add-cart'); if (!add || !add.parentNode) return;
    var b = document.getElementById('cp-lien-btn');
    if (b && b.previousElementSibling === add) return;
    if (!b) {
      b = document.createElement('button'); b.type = 'button'; b.id = 'cp-lien-btn'; b.textContent = 'Enregistrer ma configuration';
      b.addEventListener('click', ouvrir);
    }
    add.parentNode.insertBefore(b, add.nextSibling);
  }
  var dlg = null, retour = null;
  function fermer() {
    if (!dlg) return; dlg.parentNode && dlg.parentNode.removeChild(dlg); dlg = null;
    document.removeEventListener('keydown', touche, true);
    if (retour) try { retour.focus({ preventScroll: true }); } catch (e) {}
  }
  function touche(e) { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); fermer(); } }
  function dire(t) { var p = dlg && dlg.querySelector('.cpl-etat'); if (p) p.textContent = t; }
  function copier(t, ok) {
    var inp = dlg && dlg.querySelector('input');
    var repli = function () {
      var r = false; if (inp) { inp.focus(); inp.select(); try { r = document.execCommand('copy'); } catch (e) { r = false; } }
      dire(r ? ok : 'La copie n\'a pas marché : sélectionnez le lien et copiez-le.');
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(function () { dire(ok); }, repli); else repli();
  }
  function ouvrir() {
    var A = getApp(); if (!A || !A.S) return;
    fermer(); retour = document.activeElement;
    encoder(etat(A)).then(function (code) {
      var lien = adresse(code);
      dlg = document.createElement('div'); dlg.id = 'cp-lien-dlg'; dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-labelledby', 'cp-lien-t');
      dlg.innerHTML = '<div class="cpl-box"><div class="cpl-tete"><h2 id="cp-lien-t">Gardez votre configuration</h2><button type="button" class="cpl-x" aria-label="Fermer">✕</button></div>' +
        '<p class="cpl-phrase">Ce lien garde tous vos réglages. Ouvrez-le quand vous voulez : votre configuration revient telle quelle.</p>' +   /* R214 (Romain) */
        '<input type="text" readonly aria-label="Lien de votre configuration">' +
        '<div class="cpl-bas"><button type="button" class="cpl-copier">Copier le lien</button><button type="button" class="cpl-mail">Envoyer par e-mail</button></div>' +
        '<p class="cpl-etat" role="status" aria-live="polite"></p></div>';
      var inp = dlg.querySelector('input'); inp.value = lien;
      inp.addEventListener('focus', function () { inp.select(); });
      dlg.querySelector('.cpl-x').addEventListener('click', fermer);
      dlg.addEventListener('mousedown', function (e) { if (e.target === dlg) fermer(); });
      dlg.querySelector('.cpl-copier').addEventListener('click', function () { copier(lien, 'Lien copié.'); });
      dlg.querySelector('.cpl-mail').addEventListener('click', function () {
        /* garde d'AUDIT (15:59) : certaines messageries coupent un lien mailto au-delà d'environ 2 000 caractères */
        if (lien.length > MAX_MAIL) { copier(lien, 'Ce lien est trop long pour un e-mail : il a été copié. Collez-le dans un message ou une note.'); return; }
        var sujet = 'Ma configuration Creapanel : ' + String(nomProduit()).replace(/\s*[|–—-]\s*Creapanel.*$/i, '').trim();
        var corps = 'Voici le lien de ma configuration sur creapanel.com :\n' + lien;   /* R214 (Romain) : sans la phrase de fin */
        window.location.href = 'mailto:?subject=' + encodeURIComponent(sujet) + '&body=' + encodeURIComponent(corps);
      });
      (document.getElementById('stage') && document.getElementById('stage').classList.contains('cfgfs-on') ? document.getElementById('stage') : document.body).appendChild(dlg);
      document.addEventListener('keydown', touche, true);
      try { dlg.querySelector('.cpl-copier').focus({ preventScroll: true }); } catch (e) {}
    });
  }
  function injectCss() {
    if (document.getElementById('cp-lien-css')) return;
    var st = document.createElement('style'); st.id = 'cp-lien-css';
    st.textContent =
      '#cp-lien-btn{display:block;width:100%;min-height:44px;margin:8px 0 0;padding:0 14px;border:1.5px solid #0d3527;border-radius:8px;background:#fff;color:#0d3527;font:inherit;font-size:14px;font-weight:700;cursor:pointer}' +
      '#cp-lien-btn:hover{background:#f4f1eb}#cp-lien-btn:focus-visible,#cp-lien-dlg button:focus-visible,#cp-lien-dlg input:focus-visible{outline:3px solid #0b3527;outline-offset:2px}' +
      '#cp-lien-dlg{position:fixed;inset:0;z-index:10060;display:flex;align-items:center;justify-content:center;padding:8px;background:rgba(0,0,0,.35)}' +
      '#cp-lien-dlg .cpl-box{width:min(480px,100%);max-height:calc(100vh - 16px);overflow:auto;box-sizing:border-box;padding:12px 16px 16px;border-radius:12px;background:#fff;color:#1f2937;box-shadow:0 10px 30px rgba(0,0,0,.25);font-size:14px;line-height:1.45}' +
      '#cp-lien-dlg .cpl-tete{display:flex;align-items:center;justify-content:space-between;gap:8px}#cp-lien-dlg h2{margin:0;font-size:16px;font-weight:700;letter-spacing:0;text-transform:none}' +
      '#cp-lien-dlg .cpl-x{min-width:44px;min-height:44px;margin-right:-10px;border:0;background:none;color:#1f2937;font-size:18px;cursor:pointer}' +
      '#cp-lien-dlg .cpl-phrase{margin:4px 0 10px}' +
      '#cp-lien-dlg input{width:100%;box-sizing:border-box;min-height:44px;padding:0 10px;border:1px solid #9ca3af;border-radius:8px;font-size:14px;color:#374151;background:#f9fafb}' +
      '#cp-lien-dlg .cpl-bas{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}#cp-lien-dlg .cpl-bas button{flex:1 1 180px;min-height:44px;padding:0 12px;border-radius:8px;font:inherit;font-weight:700;cursor:pointer}' +
      '#cp-lien-dlg .cpl-copier{border:0;background:#1f3d2b;color:#fff}#cp-lien-dlg .cpl-mail{border:1.5px solid #1f3d2b;background:#fff;color:#1f3d2b}' +
      '#cp-lien-dlg .cpl-etat{margin:8px 0 0;min-height:1.45em;color:#1f3d2b;font-weight:600}';
    (document.head || document.documentElement).appendChild(st);
  }

  /* ── 3. Le retour par le lien ── */
  function retirerHash() { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
  function relire(A, code) {
    decoder(code).then(function (obj) {
      if (!obj || typeof obj !== 'object' || !obj.s) throw new Error('forme');
      if (obj.p !== handle()) { retirerHash(); toast('Ce lien correspond à un autre produit : la fiche s\'ouvre avec ses réglages habituels.'); return; }
      var s = obj.s, perdus = [];
      /* le décor, comme un clic sur son choix : prix au mètre et règles suivent */
      var apres = function () {
        if (s.thk != null) {
          var al = A._eff && A._eff.thicknessRule && A._eff.thicknessRule.allowed;
          if (al && al.length && al.map(Number).indexOf(num(s.thk)) < 0) { perdus.push({ t: 'ep', e: num(s.thk) }); delete s.thk; }
        }
        Object.keys(s).forEach(function (k) {
          if (k === 'variant' || PASSAGERES.indexOf(k) >= 0 || !(k in A.S)) return;
          var a = A.S[k], b = s[k];
          if (sorte(a) !== sorte(b) && a !== null && b !== null) return;   /* même type, ou une valeur vide d'un côté */
          A.S[k] = b;
        });
        try { A.render(); } catch (e) { console.warn('[cp-lien]', e); }
        retirerHash();
        if (!perdus.length) { toast('Votre configuration est revenue, au prix du jour.'); return; }
        var phr = perdus.map(function (x) { return x.t === 'decor' ? 'le décor « ' + x.nom + ' »' : 'l\'épaisseur ' + x.e + ' mm'; });
        toast(perdus.length > 1 ? 'Certains éléments ne sont plus proposés : ' + phr.join(', ') + '. Le reste de votre configuration est revenu.'
          : perdus[0].t === 'decor' ? 'Le décor « ' + perdus[0].nom + ' » n\'est plus proposé : choisissez-en un autre. Le reste de votre configuration est revenu.'
          : 'L\'épaisseur ' + perdus[0].e + ' mm n\'est plus proposée : nous avons repris l\'épaisseur par défaut. Le reste de votre configuration est revenu.');
      };
      if (s.variant && s.variant !== A.S.variant) {
        var o = document.querySelector('#variants-container .variant-opt[data-variant="' + String(s.variant).replace(/"/g, '') + '"]');
        if (o && o.style.display !== 'none') { o.click(); setTimeout(apres, 600); return; }
        perdus.push({ t: 'decor', nom: obj.n || s.variant });
      }
      apres();
    }).catch(function (e) {
      retirerHash(); toast('Ce lien ne peut pas être relu : la fiche s\'ouvre avec ses réglages habituels.');
      console.warn('[cp-lien]', e && e.message);
    });
  }

  /* ── Branchement : le moteur prêt (et ses modules, qui enveloppent son rendu), le bouton posé à chaque rendu ── */
  var essais = 0, t0 = setInterval(function () {
    var A = getApp();
    if (A && A.S && typeof A.render === 'function' && document.getElementById('btn-add-cart')) {
      clearInterval(t0); injectCss(); bouton();
      var r0 = A.render; A.render = function () { var r = r0.apply(this, arguments); try { bouton(); } catch (e) {} return r; };
      var h = /^#cfg=(.+)$/.exec(location.hash || '');
      if (h) setTimeout(function () { relire(A, h[1]); }, 1500);           /* après les modules, qui se branchent dans la 1re seconde */
    } else if (++essais > 300) clearInterval(t0);
  }, 100);
})();
